// Owns React island roots and their teardown before imperative views replace DOM.
import { createRoot, type Root } from 'react-dom/client';
import { ModeWheel, type Experience } from './components/01-ModeWheel';
const roots = new Set<Root>();
let modeIsland: { host: HTMLDivElement; root: Root } | undefined;
/** Incremental migration boundary: React exclusively owns these islands; unmount before DOM replacement. */
export function mountModeWheel(
  active: Experience,
  labels: Record<Experience, string>,
  onSelect: (value: Experience) => void,
  available: Experience[],
  renderIcon: (value: Experience) => SVGSVGElement,
) {
  if (!modeIsland) {
    const host = document.createElement('div');
    host.className = 'mode-wheel-host';
    const root = createRoot(host);
    roots.add(root);
    modeIsland = { host, root };
  }
  const { host, root } = modeIsland;
  root.render(
    <ModeWheel
      active={active}
      labels={labels}
      onSelect={onSelect}
      available={available}
      renderIcon={renderIcon}
    />,
  );
  return host;
}
/** Unmount every island and release its root before replacing the surrounding view. */
export function clearReactViews(preserveNavigation = false) {
  for (const root of roots) {
    if (preserveNavigation && root === modeIsland?.root) continue;
    root.unmount();
    roots.delete(root);
  }
  if (!preserveNavigation) modeIsland = undefined;
}
